import { UploadStatus } from "./upload-status";

interface IAccountCenterFile {
  status: UploadStatus;
  file: File;
}

export default class AccountCenterFile implements IAccountCenterFile {
  public status: UploadStatus;
  public file: File;

  constructor(status: UploadStatus, file: File) {
    this.status = status;
    this.file = file;
  }

  get Status() {
    return this.status;
  }

  set Status(status: UploadStatus) {
    this.status = status;
  }

  get File() {
    return this.file;
  }
}
